import React, { useState } from "react";
import { Carousel } from "antd";

const MyCarousel = ({ screen }) => {
  const [dotPosition] = useState("top");

  console.log(screen);
  return (
    <Carousel dotPosition={dotPosition} autoplay>
      {screen.map((v, k) => (
        <div key={k}>
          <img src={v} alt="project_screen" style={{ width: "100%" }} />
        </div>
      ))}
    </Carousel>
  );
};
export default MyCarousel;
